import React from 'react';
import { Filter } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLingui } from '@lingui/react/macro';

interface FilterDropdownButtonProps extends React.ComponentPropsWithoutRef<typeof Button> {
  isOpen: boolean;
}

/**
 * Icon button that triggers the filter dropdown menu
 * Positioned to the left of the search field
 */
export const FilterDropdownButton = React.forwardRef<
  HTMLButtonElement,
  FilterDropdownButtonProps
>(({ isOpen, ...props }, ref) => {
  const { t } = useLingui();
  
  return (
    <Button
      ref={ref}
      variant="outline"
      size="icon"
      className="h-10 w-10"
      aria-label={t`Add filter`}
      aria-expanded={isOpen}
      aria-haspopup="true"
      {...props}
    >
      <Filter className="h-4 w-4" />
    </Button>
  );
});

FilterDropdownButton.displayName = 'FilterDropdownButton';